import { render, staticRenderFns } from "./CatalogPropertyCard.vue?vue&type=template&id=3e912f5d&scoped=true"
import script from "./CatalogPropertyCard.vue?vue&type=script&lang=js"
export * from "./CatalogPropertyCard.vue?vue&type=script&lang=js"
import style0 from "./CatalogPropertyCard.vue?vue&type=style&index=0&id=3e912f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e912f5d",
  null
  
)

export default component.exports